import { Clear as ClearIcon, FileDownload as ExportIcon } from '@mui/icons-material'
import { Box, Button, Tooltip, IconButton } from '@mui/material'
import { GridToolbar, GridFilterModel } from '@mui/x-data-grid-pro'
import React from 'react'

interface FeedbackGridToolbarProps {
	filterModel: GridFilterModel
	onClearFilters: () => void
	onExport: () => void
	exporting: boolean
	translations: Record<string, string>
}

export const FeedbackGridToolbar: React.FC<FeedbackGridToolbarProps> = ({
	filterModel,
	onClearFilters,
	onExport,
	exporting,
	translations,
}) => {
	return (
		<Box
			className="MuiDataGrid-toolbarContainer"
			sx={{ display: 'flex', justifyContent: 'space-between', p: 1, alignItems: 'center' }}
		>
			<Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
				{filterModel.items.length > 0 && (
					<Button
						variant="contained"
						size="small"
						startIcon={<ClearIcon />}
						onClick={onClearFilters}
						sx={{ height: 32 }}
						className="!bg-primary"
					>
						{translations.clearFilters || 'Clear Filters'}
					</Button>
				)}
			</Box>
			<Tooltip title={translations.exportToCsv || 'Export to CSV'}>
				<IconButton onClick={onExport} disabled={exporting} size="small">
					<ExportIcon />
				</IconButton>
			</Tooltip>
		</Box>
	)
}
